import { logger } from '#pplx/frontend/logger/browser.js';
export function reloadWindow(reason) {
    logger.info('Reloading window', { reason, url: window.location.href });
    window.location.reload();
}
//# sourceMappingURL=reloadWindow.js.map